export const RequestStatus = {
  UNINITIALIZED: 'uninitialized',
  PENDING: 'pending',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed'
};

// Scopes
export const KNOWLEDGE_ACCESS_SCOPE = 'service-knowledge-access';
export const BLOG_ACCESS_SCOPE = 'blog-access';
export const LANDING_PAGES_ACCESS_SCOPE = 'landingpages-access';
export const WEBSITE_PAGES_ACCESS_SCOPE = 'sitepages-access';